import React from 'react';
import { Route } from 'react-router-dom';
import { L } from '../../lib/i18n';
import { SigningPage } from './SigningPage';

export const routes = [<Route key="3" path="/signing" component={SigningPage} />];

export const navigation = [{ name: L('signing'), link: '/signing/message', icon: 'Sign' }];
